import { createContext } from "react";
import { MapEntryStore } from "../../store";

export const MapEntryContext = createContext<MapEntryStore | null>(null);
